import React from 'react';
import { connect } from 'react-redux';
import RequestVideoPanel from '../../../demo/components/submission/RequestVideoPanel';
import { IRootState } from '../../../shared/reducers';
import Header from '../header/Header';

interface IProps {
  history: any;
}

class VideosRequest extends React.Component<IProps, any> {
  render() {
    let className = 'figaro-content';
    return (
      <div className="figaro-container">
        <Header selectedMenu="videos" history={this.props.history} />
        <div className={className}>
          <RequestVideoPanel history={this.props.history} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IRootState) => {
  return {};
};

export default connect(mapStateToProps, {})(VideosRequest);
